import type { Comment } from '../../../shared/api/types'
import { authorDisplayName } from '../../../shared/utils/formatAuthor'

type Props = {
  parent: Comment
  onClear: () => void
}

/** Плашка «↳ Ответ <автору>: <начало текста> ×» над инпутом отправки. */
export function ReplyHintBar({ parent, onClear }: Props) {
  const author = parent.user ? authorDisplayName(parent.user) : '—'
  const preview = !parent.text
    ? 'Картинка'
    : parent.text.length > 80
      ? parent.text.slice(0, 80) + '…'
      : parent.text
  return (
    <div className="flex items-start gap-2 rounded-md border border-brand-200 bg-brand-50 px-2 py-1 text-[11px] text-brand-800">
      <div className="min-w-0 flex-1">
        <span className="font-medium">↳ Ответ {author}:</span>{' '}
        <span className="text-brand-700">{preview}</span>
      </div>
      <button
        type="button"
        onClick={onClear}
        title="Отменить ответ"
        className="shrink-0 rounded px-1 text-brand-700 hover:bg-brand-100"
      >
        ×
      </button>
    </div>
  )
}
